module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('label')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.item[_vm.addLanguageSuffix('label')]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.addLanguageSuffix('label'), $$v)
      },
      expression: "item[addLanguageSuffix('label')]"
    }
  })], 1), _vm._v(" "), _c('link-component', {
    key: ("submenu_link_" + _vm.itemKey),
    attrs: {
      "errors": _vm.errors['link']
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2d61452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Menus/SubmenuItem.vue
// module id = 802
// module chunks = 0